import React from "react";
import Index from "./index";
import OurWorkTable from "./OurWorkTable";

const OurWorks = () => {
    const { ourWork, onDelete, loading, history, search, setSearch, dispatch } = Index();

    return (
        <OurWorkTable
            heading="All Works"
            styleGuides={ourWork}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
            dispatch={dispatch}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(OurWorks, comparisonFn);
